import { render } from "./ShowConjunction.vue?vue&type=template&id=a72b73d4&scoped=true"
import script from "./ShowConjunction.vue?vue&type=script&lang=js"
export * from "./ShowConjunction.vue?vue&type=script&lang=js"

import "./ShowConjunction.vue?vue&type=style&index=0&id=a72b73d4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a72b73d4"]])

export default __exports__